import { useId } from 'react';
import { Icon, chevronDown } from '@wordpress/icons';


export default function Select(props) {
    const {
        label,
        selectOnChange,
        options,
        value,
        ...restOfProps
    } = props;
    const generatedId = useId();
    const inputId = restOfProps.id || `wc-blocks-components-select-${ generatedId }`;
    return(
        <div className="wc-blocks-components-select">
            <div className="wc-blocks-components-select__container">
                <label
                    htmlFor={ inputId }
                    className="wc-blocks-components-select__label"
                >
                    { label }
                </label>
                <select 
                    className="wc-blocks-components-select__select"
                    id={ inputId }
                    size="1"
                    onChange={ selectOnChange }
                    value={ value }
                >
                    { options.map( ( option ) => (
                        <option
                            key={ option.value }
                            value={ option.value }
                            data-alternate-values={ `[${ option.label }]` }
                            disabled={
                                option.disabled !== undefined
                                    ? option.disabled
                                    : false
                            }
                        >
                            { option.label }
                        </option>
					) ) }
                </select>
                <Icon
                    className="wc-blocks-components-select__expand"
                    icon={ chevronDown }
                />
            </div>
        </div>
    )
}